import styled from 'styled-components';

export const TableWrapper = styled.div`
    height: 200px;
    border: ${({ theme }) => `${theme.border.width.standard}${theme.units} solid ${theme.palette.border.light}`};
    border-radius: ${({ theme }) => `${theme.border.radius(3)}${theme.units}`};
    margin-bottom: 8px;
    overflow: hidden;
`;
